import TextTbCell from './TextTbCell';

export default TextTbCell;
